import { render, staticRenderFns } from "./ReserveUnit.vue?vue&type=template&id=bb26408a"
import script from "./ReserveUnit.vue?vue&type=script&lang=js"
export * from "./ReserveUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports